import React from 'react';
import { useResultAnalysis } from '../../../../../../hooks/useResultAnalysis';
import { Filter } from '../../../Filter/Filter';

import { Checkbox } from 'rsuite';
import styles from './FilterStoreAnalysisTab.module.scss';

export const FilterStoreOptimizedAnalysisTab = () => {
  const { handlers, states } = useResultAnalysis();
  const { handleSelectStoreId } = handlers;
  const { analysis, stores, controlStore, storesIdWithoutResults } = states;

  const allowedStores = stores.filter(item => ![controlStore?.storeId].concat(storesIdWithoutResults).includes(item.storeId));

  const checkedItems = analysis.filters.storesSelected?.length > 0 && analysis.filters.storesSelected?.length === allowedStores?.length;
  const indeterminateItems = analysis.filters.storesSelected?.length > 0 && !checkedItems;

  const itemsDisabled = stores
    .filter(item => [controlStore?.storeId].includes(item.storeId))
    .map(item => item.storeId)
    .concat(storesIdWithoutResults) as any[];

  return (
    <div className={styles.container}>
      <span className={styles.label}>Loja otimizada: </span>
      <Filter
        data={stores.map(item => {
          return {
            value: item.storeId,
            label: item.storeName,
          };
        })}
        disabledItemValues={itemsDisabled}
        selectedItemsId={analysis.filters.storesSelected}
        onSelect={handleSelectStoreId}
        onClean={() => handleSelectStoreId([])}
        isMultiple
        placeholder="Selecione as lojas"
        searchable
        cleanable={false}
        locale={{
          noResultsText: stores.length === 0 ? 'Carregando lojas...' : 'Nenhum item encontrado',
          searchPlaceholder: 'Pesquisar lojas',
        }}
        renderExtraFooter={() => (
          <div className={styles['render-extra-footer']}>
            <Checkbox
              block
              indeterminate={indeterminateItems}
              checked={checkedItems}
              onChange={(_value: any, checked: boolean) => {
                const nextValue = checked
                  ? stores.filter(item => ![controlStore?.storeId].concat(storesIdWithoutResults).includes(item.storeId)).map(item => item.storeId)
                  : [];
                handleSelectStoreId(nextValue);
              }}
            >
              Selecionar todas as lojas
            </Checkbox>
          </div>
        )}
        renderMenuItem={(label, item) => {
          const isDisabled = itemsDisabled.includes(item.value);
          return (
            <div className={styles['render-menu-item']}>
              <span>{label}</span>
              {isDisabled && <span className={styles['no-results']}>Sem resultados disponíveis</span>}
            </div>
          );
        }}
      />
    </div>
  );
};
